import React, { FC } from 'react';
import { Reaction, ReactionProps } from 'api/conversations/types';
import { Avatar } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';
import styles from './summary-users.module.css';

type SummaryUserProps = {
  summaryTab: ReactionProps;
};

export const SummaryUsers: FC<SummaryUserProps> = ({ summaryTab }) => (
  <>
    {summaryTab.users.map((user) => (
      <div key={`user-${user.userId}`} className={styles.wrapper}>
        <Avatar
          className={styles.avatar}
          name={fullName(user)}
          src={user.photoUrl}
        />
        <span className={styles.reaction}>
          {Reaction[summaryTab.reactionType]}
        </span>
        <div>{fullName(user)}</div>
      </div>
    ))}
  </>
);
